jQuery(document).ready(($) => {
    // initialize FitVids
    // documentation: https://github.com/davatron5000/FitVids.js
    // $(".front-page, .hentry").fitVids();


    $('#close_menu').on('click', function(event) {
        $('#menu-toggle').prop('checked', false);
    });

    $('.date_picker').datepicker({
        dateFormat: 'dd/mm/yy',
        changeMonth: true,
        changeYear: true
    });

    $('#menu_trigger').on("click", function() {
        var x = document.getElementById("site_header_contact");

        $('.open').toggle();
        $('.close').toggle();

        if (x.style.display === "none") {
            //$('#menu_wrapper').animate({ width: "toggle" });
            $('#menu_wrapper').toggleClass('toggled');
            setTimeout(
                function() {
                    $('#site_header_contact').css("display", "flex");
                }, 500);

        } else {
            $('#site_header_contact').css("display", "none");
            //$('#menu_wrapper').animate({ width: "toggle" });
            $('#menu_wrapper').toggleClass('toggled');
        }
    });

    $('#search_trigger').on("click", function() {
        $('.holiday-search').toggleClass('toggled');
    });

    $(".owl-carousel.archive").owlCarousel({
        items: 1,
        dots: false,
        stagePadding: 25,
        margin: 10,
    });

    $(".owl-carousel.single-holiday-images").owlCarousel({
        loop: true,
        dots: false,
        stagePadding: 45,
        margin: 20,
        nav: true,
        responsive: {
            0: {
                items: 1,
                stagePadding: 25,
            },
            768: {
                items: 3,
            }
        }
    });

    $(".owl-carousel.recommended").owlCarousel({
        dots: false,
        stagePadding: 25,
        margin: 10,
        responsive: {
            0: {
                items: 1
            },
            768: {
                items: 4,
                nav: true
            }
        }
    });

    $(".owl-carousel.ship-images").owlCarousel({
        items: 1,
        dots: false,
        nav: true,
        margin: 10,
    });


    $('#view_more').on("click", function(e) {
        e.preventDefault();
        $('.view-more').slideToggle('slow');
        $(this).text($(this).text() == 'View full itinerary' ? "Hide full itinerary" : "View full itinerary");
    });


});

WebFont.load({
    google: {
        families: ['Cabin:400,400i,700,700i', 'Raleway:600,800'],
        //text: 'abcdedfghijklmopqrstuvwxyz!'
    }
});